import { useState, useEffect, useCallback } from "react";
import { FaBookOpen, FaCalendarAlt, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import Loading from "../loading/loading";
import { viewDashboard, viewDashboardEvents } from "../http/api";
import { useAuth } from "../http/authcontex";
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import '../common/style.css';
import './dashboard.css';

export default function DashboardComponent() {

    const localizer = momentLocalizer(moment);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const authContext = useAuth();
    const [filteredEvents, setFilteredEvents] = useState([]);

    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    useEffect(() => {
        localStorage.setItem('sb|sidebar-toggle', isSidebarOpen);
    }, [isSidebarOpen]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    const [openCases, setOpenCases] = useState(0);
    const [closedCases, setClosedCases] = useState(0);
    const [totalCases, setTotalCases] = useState(0);
    const [cancelledCases, setCancelled] = useState(0);


    const viewDashboardDetails = useCallback(() => {
        setLoading(true);
        viewDashboard()
            .then(response => {
                if (response.status === 200) {
                    setOpenCases(response.data.open);
                    setClosedCases(response.data.close);
                    setTotalCases(response.data.total);
                    setCancelled(response.data.cancelled)
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    authContext.logout();
                    navigate('');
                } else {
                    console.error('Error fetching dashboard details:', error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        viewDashboardDetails();
    }, [viewDashboardDetails]);

    // Helper function to get start and end dates of a month
    const getMonthDateRange = (date) => {
        const start = moment(date).startOf('month').format('YYYY-MM-DD');
        const end = moment(date).endOf('month').format('YYYY-MM-DD');
        return { start, end };
    };

    const fetchEventsForMonth = useCallback((startDate, endDate) => {
        if (!startDate || !endDate) {
            console.error("Invalid start or end date for API call.");
            return;
        }

        setLoading(true);
        viewDashboardEvents(startDate, endDate)
            .then(response => {
                if (response.status === 200) {
                    setFilteredEvents(response.data);
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    authContext.logout();
                    navigate('');
                } else {
                    console.error('Error fetching events:', error);
                }
            });
    }, [authContext, navigate]);

    //Load events for the current month on initial render
    useEffect(() => {
        const { start, end } = getMonthDateRange(new Date());
        fetchEventsForMonth(start, end);
    }, [fetchEventsForMonth]);

    //Handle month navigation in the calendar
    const handleMonthChange = (date) => {
        const { start, end } = getMonthDateRange(date);
        fetchEventsForMonth(start, end);
    };


    const handleDateClick = (date) => {
        alert(`Details for ${date}: More info here!`); // Add more logic for showing detailed popup
    };

    return (
        <div className="DashboardComponent">
            {loading && <Loading />}
            <div className={`sb-nav-fixed ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
                <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav">
                    <SideNave isSidebarOpen={isSidebarOpen} />
                    <div id="layoutSidenav_content">
                        <main>
                            <div className="container-fluid px-4">
                                <h4 className="mt-4">Dashboard</h4>
                                <div className="row">
                                    <div className="col-xl-3 col-md-6">
                                        <div className="card bg-info text-white mb-4 shadow border-0">
                                            <div className="card-body d-flex align-items-center">
                                                <FaCalendarAlt style={{ fontSize: '2rem' }} className="me-2" />
                                                <span>Total Cases</span>
                                            </div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <p className="text-white stretched-link">{totalCases}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-md-6">
                                        <div className="card bg-warning text-white mb-4 shadow border-0">
                                            <div className="card-body d-flex align-items-center">
                                                <FaBookOpen style={{ fontSize: '2rem' }} className="me-2" />
                                                <span>Open Cases</span>
                                            </div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <p className="text-white stretched-link">{openCases}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-md-6">
                                        <div className="card bg-success text-white mb-4 shadow border-0">
                                            <div className="card-body d-flex align-items-center">
                                                <FaCheckCircle style={{ fontSize: '2rem' }} className="me-2" />
                                                <span>Completed Cases</span>

                                            </div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <p className="text-white stretched-link">{closedCases}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-md-6">
                                        <div className="card bg-danger text-white mb-4 shadow border-0">
                                            <div className="card-body d-flex align-items-center">
                                                <FaTimesCircle style={{ fontSize: '2rem' }} className="me-2" />
                                                <span>Cancelled Cases</span>
                                            </div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <p className="text-white stretched-link">{cancelledCases}</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card mb-4">
                                            <div className="card-header">
                                                <FaCalendarAlt className="me-1" /> Date Wise Activity
                                            </div>
                                            <div className="card-body">
                                                <div className="date-cases-container">

                                                    {/* Calendar */}
                                                    <Calendar
                                                        localizer={localizer}
                                                        events={filteredEvents}
                                                        startAccessor="start"
                                                        endAccessor="end"
                                                        style={{ height: 500 }}
                                                        popup={true} // Enables the popup to show all events on click
                                                        onSelectEvent={(event) => alert(`Activity Details: ${event.title}`)} // Handles event clicks
                                                        onSelectSlot={(slotInfo) => handleDateClick(slotInfo.start)} // Handles date clicks 
                                                        views={["month"]}
                                                        defaultView="month"
                                                        onNavigate={handleMonthChange} // Triggered when the month changes
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
}
